

import {
	arrayRange,
	asyncCustomValid,
	byteLength,
	compareSize,
	customValid,
	length,
	moneyRange,
	numberPoint,
	numberRange,
	rangeSize,
	reg,
	regValid,
	required,
	requiredCustom,
	valuesNoZero,
} from 'valid_project';

export {
	arrayRange,
	asyncCustomValid,
	byteLength,
	compareSize,
	customValid,
	length,
	moneyRange,
	numberPoint,
	numberRange,
	rangeSize,
	reg,
	regValid,
	required,
	requiredCustom,
	valuesNoZero,
};

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

export function validTel (str) {
  const reg = /^((0\d{2,3}-\d{7,8})|(1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}))$/
  return reg.test(str)
}

export function validEmail(str) {
  const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
  return reg.test(str)
}

export function validPwd(str) {
  const reg = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9\D]{6,32})$/
  return reg.test(str)
}

// 自定义规则
export function requiredCustomVm(message, fn, trigger = 'change') {
	return {
    required: true,
    message: message,
    trigger: trigger,
    validator: (vm, vaild, value) => {
      if (typeof fn == 'function') {
        return fn(value, vm) ? undefined : message;
      }
    }
  };

}